<template>
  <div class="start-session-container">
    <MainNavigation
      page-name="Join Teams"
      :routeIndex="routeIndex"
      :currentClass="currentClass"
    />
    <Loader v-if="!currentClass || !currentSession" />
    <ClassItemBanner
      v-if="currentClass"
      :sessionEnded="true"
      :currentClass="currentClass"
    />
    <div v-if="currentClass && currentSession">
      <h1>Current Session</h1>
      <p v-if="currentSession.sessionSettings.isTimeLimitEnabled">
        <!-- Game Mode: {{ currentSession.sessionSettings.gameMode
        }}<br /> -->
        Time Limit:
        {{ currentSession.sessionSettings.timeLimit }} minutes
      </p>
      <label for="file">
        <strong
          >{{ numStudentsJoined }} of {{ allStudents.length }} students have
          joined teams:
        </strong>
      </label>
      <progress
        id="file"
        :value="numStudentsJoined"
        :max="allStudents.length"
      ></progress>
    </div>
    <div style="margin: 1rem 0" v-if="dataUpdated">
      <!-- <label for="figures">Select a figure:</label> -->
      <select
        name="figures"
        id="figures"
        v-model="currentSession.selectedStorybox"
        @change="figureSelectionChanged"
        required
      >
        <option disabled selected value="">Select a Figure</option>
        <option
          v-for="storybox in storyboxList"
          :key="storybox.storyboxId"
          :value="storybox"
        >
          {{ storybox.storyboxName }}
        </option>
      </select>
      <select
        name="levels"
        id="levels"
        required
        v-model="currentSession.selectedLevel"
        v-if="
          currentSession.levelList.length != 0 &&
          currentSession.selectedStorybox != ''
        "
        @change="levelSelectionChanged"
      >
        <option disabled selected value="">Select a Room</option>
        <option v-for="level in levelList" :key="level.levelId" :value="level">
          {{ level.levelName }}
        </option>
      </select>
    </div>
    <button
      :disabled="isDisabled"
      :class="{ disabled: isDisabled }"
      @click="checkForModal"
      v-if="dataUpdated"
    >
      Start Session
    </button>
    <div v-if="dataUpdated">
      <Tabs>
        <Tab :title="'Teams' + ' (' + groupCount + ')'" :tabId="'Team'">
          <div class="group-list">
            <div
              v-for="group in allGroups"
              :class="['group-block', group.groupName]"
              :key="group.groupName"
            >
              Team {{ group.groupName }} ({{ group.studentList.length }})

              <div class="student-list">
                <div
                  v-for="student in group.studentList"
                  class="student-name-item"
                  style="white-space: pre-line"
                  :key="student.studentId"
                >
                  <img
                    class="bootStudent"
                    @click="showBootModal(student, group)"
                    src="@/assets/remove_circle_outline_24px.svg"
                  />
                  <p>{{ student.studentName }}</p>
                </div>
              </div>
            </div>
          </div>
        </Tab>
        <Tab :title="'Students' + ' (' + studentCount + ')'" :tabId="'Student'">
          <div class="student-list">
            <div
              v-for="student in allStudents"
              class="student-list student-list-tab"
              style="white-space: pre-line"
              :key="student.studentId"
            >
              <div class="left-side">
                <div class="indicator-block">
                  <ul>
                    <li v-if="student.connectionState >= 1">
                      <div class="online"></div>
                    </li>
                    <li v-else><div class="offline"></div></li>
                    <li v-if="student.connectionState >= 2">
                      <div class="success">
                        <img src="@/assets/connection_group_24px.svg" />
                      </div>
                    </li>
                    <li v-else>
                      <div class="error">
                        <img src="@/assets/connection_group_24px.svg" />
                      </div>
                    </li>
                  </ul>
                </div>
                <p v-if="student.studentNickname == ''">
                  {{ student.studentName }}
                </p>
                <p v-else>
                  {{ student.studentName }} ({{ student.studentNickname }})
                </p>
              </div>
              <div class="reset-student" @click="resetStudent(student)">
                <img src="@/assets/refresh_24px.svg" />
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal">
      <template v-slot:header>
        Some of your students have not <br />joined a team:
      </template>

      <template v-slot:body>
        <div class="student-list">
          <div
            v-for="student in allStudents.filter(
              (item) => item.connectionState == 0
            )"
            class="student-list"
            style="white-space: pre-line"
            :key="student.studentId"
          >
            {{ student.studentName }}
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div class="modal-button-group">
          <button @click="closeModal">Cancel</button>
          <button @click="startSessionAnyway">Start Anyway</button>
        </div>
      </template>
    </Modal>
    <Modal v-show="isBootModalVisible" @close="closeBootModal">
      <template v-slot:header>
        <b>Removing Student From Team</b>
      </template>

      <template v-slot:body>
        You are removing
        <b>{{ studentToBoot ? studentToBoot.studentName : "" }}</b> from Team
        {{ groupToBootFrom ? groupToBootFrom.groupName : "" }}. Are you sure you
        want to do this?
      </template>

      <template v-slot:footer>
        <div class="modal-button-group">
          <button class="cancel-button" @click="closeBootModal">Cancel</button>
          <button @click="confirmBoot">Confirm</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import Modal from "../components/Modal.vue";
import Tab from "../components/Tab.vue";
import Tabs from "../components/Tabs.vue";
import Loader from "../components/Loader.vue";
import ClassItemBanner from "../components/ClassItemBanner.vue";

export default {
  name: "Start Session",

  components: {
    MainNavigation,
    Modal,
    Tab,
    Tabs,
    Loader,
    ClassItemBanner,
  },
  props: ["routeIndex"],
  data() {
    return {
      isMapShow: false,
      isModalVisible: false,
      isBootModalVisible: false,
      studentToBoot: null,
      groupToBootFrom: null,
      // groupCount: this.currentSession.groupList.length,
      // studentCount: this.$store.state.currentClass.studentCount,
    };
  },
  computed: {
    currentClass() {
      const result = this.$store.state.allClasses.filter((response) => {
        return response.classInfo.nickname === this.$route.params.name;
      });
      return result[0];
    },
    currentSession() {
      return this.$store.state.currentSession;
    },
    groupCount() {
      return this.allGroups.length;
    },
    studentCount() {
      return this.currentSession.studentList.length;
    },
    userType() {
      return this.$store.state.userType;
    },
    levelList() {
      // if (this.userType === "Teacher") {
      //   const levelSet = this.currentSession.levelList.filter(
      //     (level) =>
      //       level.levelName == "Dressing Room" ||
      //       level.levelName == "Harlem Renaissance" ||
      //       level.levelName == "Blackbirds" ||
      //       level.levelName == "Funeral"
      //   );
      //   return levelSet;
      // } else {
      return this.currentSession.levelList;
      // }
    },
    storyboxList() {
      // if (this.userType === "Teacher") {
      //   const storySet = this.currentSession.storyboxList.filter(
      //     (storybox) => storybox.storyboxName == "Florence Mills"
      //   );
      //   return storySet;
      // } else {
      return this.currentSession.storyboxList;
      // }
    },
    allStudents() {
      return this.currentSession.studentList;
    },
    numStudentsJoined() {
      //console.log("STUDENTS", this.liveSession.studentList)
      return this.currentSession.studentList.filter(
        (student) => student.connectionState > 0
      ).length;
    },
    allGroups() {
      const newList = this.currentSession.groupList.filter(
        (group) => group.studentList.length > 0
      );
      return newList;
    },
    isDisabled() {
      return (
        this.currentSession.selectedStorybox == "" ||
        this.currentSession.selectedLevel == ""
      );
    },
    dataUpdated() {
      return this.$store.state.dataUpdated;
    },
  },
  created() {
    window.addEventListener("beforeunload", this.beforeWindowUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.beforeWindowUnload);
  },
  methods: {
    beforeWindowUnload(e) {
      e.preventDefault();
      e.returnValue = "";
    },
    figureSelectionChanged: function () {
      this.currentSession.selectedLevel = "";
      if (this.currentSession.selectedStorybox != "") {
        this.$store.commit("SEND_MESSAGE", {
          data: {
            storyboxId: this.currentSession.selectedStorybox.storyboxId,
            sessionId: this.currentSession.sessionId,
          },
          opCode: this.$store.state.opCodes.GetStoryboxSelection,
        });
      }
    },
    levelSelectionChanged: function () {
      if (
        this.currentSession.selectedStorybox != "" &&
        this.currentSession.selectedLevel != ""
      ) {
        this.$store.commit("SEND_MESSAGE", {
          data: {
            storyboxId: this.currentSession.selectedStorybox.storyboxId,
            levelId: this.currentSession.selectedLevel.levelId,
            sessionId: this.currentSession.sessionId,
          },
          opCode: this.$store.state.opCodes.GetLevelAndStoryboxSelection,
        });
      }
    },
    startSessionAnyway: function () {
      this.startSession();
      this.closeModal();
      this.viewLiveSession();
    },
    startSession: function () {
      if (
        this.currentSession.selectedStorybox != "" &&
        this.currentSession.selectedLevel != ""
      ) {
        this.$store.commit("SEND_MESSAGE", {
          data: {
            sessionId: this.currentSession.sessionId,
          },
          opCode: this.$store.state.opCodes.StartSession,
        });
        this.$store.commit("SEND_MESSAGE", {
          data: {
            levelId: this.currentSession.selectedLevel.levelId,
            sessionId: this.currentSession.sessionId,
          },
          opCode: this.$store.state.opCodes.AssignInitialArtifacts,
        });
      }
    },
    viewLiveSession: function () {
      this.$router.push({
        name: "live-session",
        params: { name: this.$store.state.currentClass.classInfo.nickname },
      });
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    showBootModal(student, group) {
      this.studentToBoot = student;
      this.groupToBootFrom = group;
      this.isBootModalVisible = true;
    },
    confirmBoot() {
      this.bootStudent(this.studentToBoot.studentId);
      this.closeBootModal();
    },
    closeBootModal() {
      this.isBootModalVisible = false;
    },
    checkForModal() {
      // console.log("NUM JOINED", this.numStudentsJoined, this.allStudents.length)
      if (this.numStudentsJoined == this.allStudents.length) {
        // console.log("Starting Session");
        this.startSession();
        this.viewLiveSession();
      } else {
        // console.log("Show Modal");
        this.showModal();
      }
    },
    bootStudent(studentId) {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          studentId: studentId,
          sessionId: this.currentSession.sessionId,
        },
        opCode: this.$store.state.opCodes.BootStudent,
      });
    },
    resetStudent(student) {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          studentId: student.studentId,
          sessionId: this.currentSession.sessionId,
        },
        opCode: this.$store.state.opCodes.ResetStudent,
      });
    }
  },
};
</script>

<style>
.start-session-container {
  text-align: left;
}

button {
  width: 100%;
}

select {
  margin-bottom: 1em;
}

.tabs {
  position: relative;
  min-height: 20rem; /* This part sucks */
  clear: both;
  margin: 25px 0;
}
.tab {
  float: left;
}
.tab label {
  background: #eee;
  padding: 10px;
  border: 1px solid #ccc;
  margin-left: -1px;
  position: relative;
  left: 1px;
}
.tab [type="radio"] {
  display: none;
}

[type="radio"]:checked ~ label {
  background: white;
  border-bottom: 1px solid white;
  z-index: 2;
}
[type="radio"]:checked ~ label ~ .content {
  z-index: 1;
}

.group-block {
  background: #f2f2f2;
  border-radius: 16px;
  margin-bottom: 20px;
  padding: 16px;
}

.modal-button-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;
}

.indicator-block ul {
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
  align-items: center;
}

.indicator-block ul li {
  display: inline-block;
  margin-right: 10px;
}

.student-list-tab {
  display: flex;
  margin: 0.5rem 0;
  align-items: center;
  justify-content: space-between;
  background: #f2f2f2;
  border-radius: 16px;
  padding: 0px 16px;
}

.online,
.offline {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background: gray;
  display: block;
}

.online {
  background: rgba(39, 174, 96, 0.8);
}

.offline {
  background: #f2c94c;
}

.error {
  opacity: 50%;
  display: flex;
  align-items: center;
}

.reset-student {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  cursor: pointer; 
}

.left-side {
  display: flex;
  align-items: center;
}

.student-name-item {
  display: flex;
}

.student-name-item img {
  margin-right: 10px;
}

.bootStudent {
  cursor: pointer;
}

.student-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.header-column {
  display: flex;
  align-items: center;
}

.icon-key-map-container {
  background: #fff;
  position: absolute;
  top: 50px;
  right: 0;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  padding: 1rem;
}
</style>